import { EffortPickerModal } from "@components/companion-v2/EffortPickerModal";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  AvailableCompanionTabs,
  useCompanion,
} from "@hooks/use-companion";
import { useCompanionV2 } from "@hooks/use-companion-v2";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useState } from "react";

export const CompanionNavButton = ({
  icon,
  title,
  onClick,
  isTabActive,
  badgeCount = 0,
}) => {
  return (
    <button
      className={`relative cursor-pointer rounded-full w-8 h-8 text-white ${
        isTabActive ? "bg-indigo-800" : "hover:bg-indigo-800/50"
      }`}
      onClick={onClick}
      data-testid={`companion-nav-${title
        .toLowerCase()
        .replace(" ", "-")}`}
    >
      <FontAwesomeIcon icon={icon} title={title} size="lg" />
      {badgeCount > 0 && (
        <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-[16px] px-1 rounded-full bg-red-500 text-white text-[10px] font-semibold flex items-center justify-center">
          {badgeCount > 9 ? "9+" : badgeCount}
        </span>
      )}
    </button>
  );
};

export const LegacyBadge = () => {
  return (
    <span className="shrink-0 rounded-full bg-gray-200 px-2 py-0.5 text-xs font-medium text-gray-600 dark:bg-gray-600 dark:text-gray-300">
      Legacy
    </span>
  );
};

export const NewSessionButton = () => {
  const { setCompanionSession, setActiveTab } = useCompanion();
  const { clearSession: clearV2Session, setEffort } =
    useCompanionV2();
  const {
    allowCompanionOptIn,
    showGlobalCompanionTierLow,
    showGlobalCompanionTierHigh,
  } = useFlags();
  const [isEffortPickerOpen, setIsEffortPickerOpen] = useState(false);

  const handleEffortSelect = (effort) => {
    setCompanionSession(null);
    setActiveTab(AvailableCompanionTabs.chat);
    clearV2Session();
    setEffort(effort);
  };

  const hasNonSupportTier =
    allowCompanionOptIn &&
    (showGlobalCompanionTierLow || showGlobalCompanionTierHigh);

  const handleClick = () => {
    if (!hasNonSupportTier) {
      handleEffortSelect("support");
    } else {
      setIsEffortPickerOpen(true);
    }
  };

  return (
    <div className="flex grow mt-2 flex-col">
      <button
        className="w-full mt-3 border-2 border-dashed border-indigo-300 rounded-full text-white py-2 text-sm transition-colors hover:bg-indigo-500/50"
        onClick={handleClick}
        data-testid="companion-new-chat-button"
      >
        <FontAwesomeIcon icon={faPlus} />{" "}
        <span className="ml-2">New Chat</span>
      </button>
      <EffortPickerModal
        isOpen={isEffortPickerOpen}
        onClose={() => setIsEffortPickerOpen(false)}
        onSelect={handleEffortSelect}
      />
    </div>
  );
};
